import { Equipment } from '../types';

export const equipmentDatabase: Equipment[] = [
  // Ubiquiti
  {
    id: 'ubnt-us-8',
    name: 'UniFi Switch 8',
    type: 'switch',
    manufacturer: 'ubiquiti',
    units: 1,
    price: 149,
    specifications: {
      ports: 8,
      power: '55W',
      speed: '1Gbps'
    }
  },
  {
    id: 'ubnt-us-16-poe',
    name: 'UniFi Switch 16 PoE',
    type: 'switch',
    manufacturer: 'ubiquiti',
    units: 1,
    price: 379,
    specifications: {
      ports: 16,
      power: '95W PoE',
      speed: '1Gbps'
    }
  },
  {
    id: 'ubnt-us-24-poe',
    name: 'UniFi Switch 24 PoE',
    type: 'switch',
    manufacturer: 'ubiquiti',
    units: 1,
    price: 549,
    specifications: {
      ports: 24,
      power: '95W PoE',
      speed: '1Gbps'
    }
  },
  {
    id: 'ubnt-u6-pro',
    name: 'UniFi 6 Professional',
    type: 'ap',
    manufacturer: 'ubiquiti',
    price: 189,
    specifications: {
      speed: 'Wi-Fi 6',
      power: 'PoE+',
      coverage: '600m²'
    }
  },
  {
    id: 'ubnt-u6-lr',
    name: 'UniFi 6 Long Range',
    type: 'ap',
    manufacturer: 'ubiquiti',
    price: 179,
    specifications: {
      speed: 'Wi-Fi 6',
      power: 'PoE+',
      coverage: '1200m²'
    }
  },
  {
    id: 'ubnt-u6-lite',
    name: 'UniFi 6 Lite',
    type: 'ap',
    manufacturer: 'ubiquiti',
    price: 99,
    specifications: {
      speed: 'Wi-Fi 6',
      power: 'PoE',
      coverage: '400m²'
    }
  },
  {
    id: 'ubnt-udm-pro',
    name: 'UniFi Dream Machine Pro',
    type: 'router',
    manufacturer: 'ubiquiti',
    units: 1,
    price: 499,
    specifications: {
      ports: 8,
      speed: '3.5Gbps',
      features: 'IDS/IPS, DPI'
    }
  },
  {
    id: 'ubnt-udm-se',
    name: 'UniFi Dream Machine SE',
    type: 'router',
    manufacturer: 'ubiquiti',
    units: 1,
    price: 679,
    specifications: {
      ports: 8,
      speed: '3.5Gbps',
      features: 'IDS/IPS, DPI, PoE+'
    }
  },

  // TP-Link
  {
    id: 'tplink-sg2008',
    name: 'TL-SG2008',
    type: 'switch',
    manufacturer: 'tp-link',
    units: 1,
    price: 89,
    specifications: {
      ports: 8,
      power: '15W',
      speed: '1Gbps'
    }
  },
  {
    id: 'tplink-sg2016',
    name: 'TL-SG2016',
    type: 'switch',
    manufacturer: 'tp-link',
    units: 1,
    price: 149,
    specifications: {
      ports: 16,
      power: '25W',
      speed: '1Gbps'
    }
  },
  {
    id: 'tplink-sg2428p',
    name: 'TL-SG2428P',
    type: 'switch',
    manufacturer: 'tp-link',
    units: 1,
    price: 299,
    specifications: {
      ports: 24,
      power: '250W PoE',
      speed: '1Gbps'
    }
  },
  {
    id: 'tplink-eap660hd',
    name: 'EAP660 HD',
    type: 'ap',
    manufacturer: 'tp-link',
    price: 199,
    specifications: {
      speed: 'Wi-Fi 6',
      power: 'PoE+',
      coverage: '500m²'
    }
  },
  {
    id: 'tplink-eap650',
    name: 'EAP650',
    type: 'ap',
    manufacturer: 'tp-link',
    price: 129,
    specifications: {
      speed: 'Wi-Fi 6',
      power: 'PoE+',
      coverage: '400m²'
    }
  },
  {
    id: 'tplink-eap225',
    name: 'EAP225',
    type: 'ap',
    manufacturer: 'tp-link',
    price: 79,
    specifications: {
      speed: 'Wi-Fi 5',
      power: 'PoE',
      coverage: '300m²'
    }
  },
  {
    id: 'tplink-er7206',
    name: 'ER7206',
    type: 'router',
    manufacturer: 'tp-link',
    units: 1,
    price: 159,
    specifications: {
      ports: 5,
      speed: '1Gbps',
      features: 'VPN, Load Balancing'
    }
  },

  // MikroTik
  {
    id: 'mikrotik-crs328',
    name: 'CRS328-24P-4S+',
    type: 'switch',
    manufacturer: 'mikrotik',
    units: 1,
    price: 299,
    specifications: {
      ports: 24,
      power: '18W',
      speed: '1Gbps'
    }
  },
  {
    id: 'mikrotik-crs312',
    name: 'CRS312-4C+8XG',
    type: 'switch',
    manufacturer: 'mikrotik',
    units: 1,
    price: 449,
    specifications: {
      ports: 12,
      power: '45W',
      speed: '10Gbps'
    }
  },
  {
    id: 'mikrotik-rb5009',
    name: 'RB5009UG+S+',
    type: 'router',
    manufacturer: 'mikrotik',
    units: 1,
    price: 219,
    specifications: {
      ports: 8,
      speed: '2.5Gbps',
      features: 'RouterOS'
    }
  },
  {
    id: 'mikrotik-rb5009upr',
    name: 'RB5009UPr+S+IN',
    type: 'router',
    manufacturer: 'mikrotik',
    units: 1,
    price: 299,
    specifications: {
      ports: 9,
      power: 'PoE-out 802.3af/at',
      speed: '2.5Gbps',
      features: 'RouterOS, 2-pin + DC jack'
    }
  },
  {
    id: 'mikrotik-css610-8p',
    name: 'CSS610-8P-2S+IN',
    type: 'switch',
    manufacturer: 'mikrotik',
    units: 1,
    price: 139,
    specifications: {
      ports: 10,
      power: 'PoE-out follows input',
      speed: '1Gbps + SFP+',
      features: 'netPower, 2-pin DC'
    }
  },
  {
    id: 'ubnt-rocket-prism-ac',
    name: 'Rocket Prism AC',
    type: 'radio-dish',
    manufacturer: 'ubiquiti',
    price: 299,
    specifications: {
      ports: 1,
      power: '24V passive PoE',
      frequency: '5GHz',
      speed: '500+ Mbps'
    }
  },
  {
    id: 'mikrotik-ccr2004',
    name: 'CCR2004-16G-2S+',
    type: 'router',
    manufacturer: 'mikrotik',
    units: 1,
    price: 599,
    specifications: {
      ports: 16,
      speed: '10Gbps',
      features: 'RouterOS, SFP+'
    }
  },

  // Generic equipment
  {
    id: 'patch-panel-24',
    name: '24-Port Patch Panel',
    type: 'patch-panel',
    manufacturer: 'ubiquiti',
    units: 1,
    price: 45,
    specifications: {
      ports: 24,
      category: 'Cat6'
    }
  },
  {
    id: 'patch-panel-48',
    name: '48-Port Patch Panel',
    type: 'patch-panel',
    manufacturer: 'ubiquiti',
    units: 2,
    price: 79,
    specifications: {
      ports: 48,
      category: 'Cat6'
    }
  },
  {
    id: 'ups-1500va',
    name: 'UPS 1500VA',
    type: 'ups',
    manufacturer: 'ubiquiti',
    units: 2,
    price: 299,
    specifications: {
      power: '1500VA',
      runtime: '10min'
    }
  },
  {
    id: 'poe-injector-60w',
    name: 'PoE+ Injector 60W',
    type: 'poe-injector',
    manufacturer: 'ubiquiti',
    price: 29,
    specifications: {
      power: '60W PoE+',
      ports: 2
    }
  },
  {
    id: 'ubnt-poe-24',
    name: '24V Passive PoE Injector',
    type: 'poe-injector',
    manufacturer: 'ubiquiti',
    price: 12,
    specifications: {
      power: '24V 12W passive',
      ports: 2
    }
  },
  {
    id: 'psu-24v-30w',
    name: '24V 30W PSU',
    type: 'psu',
    manufacturer: 'generic',
    price: 15,
    specifications: {
      power: '24V 30W',
      ports: 1
    }
  },
  {
    id: 'psu-48v-96w',
    name: '48V 96W PSU',
    type: 'psu',
    manufacturer: 'generic',
    price: 25,
    specifications: {
      power: '48V 96W',
      ports: 1
    }
  },
  {
    id: 'psu-48v-150w',
    name: '48V 150W PSU',
    type: 'psu',
    manufacturer: 'generic',
    price: 39,
    specifications: {
      power: '48V 150W',
      ports: 1
    }
  },
    {
    id: 'solar-460w',
    name: '460W Solar Panel',
    type: 'solar-panel',
    manufacturer: 'generic',
    price: 180,
    specifications: { power: '460W STC', voc: '43V' }
  },
  {
    id: 'battery-48v-100ah',
    name: '48V 100Ah LiFePO4',
    type: 'battery',
    manufacturer: 'generic',
    price: 890,
    specifications: { power: '5.12 kWh', voltage: '51.2V' }
  },
  {
    id: 'inverter-5k-48v',
    name: '5kW 48V Hybrid Inverter',
    type: 'inverter',
    manufacturer: 'generic',
    price: 1290,
    specifications: { power: '5000W AC', pv: '6500W PV' }
  },
  {
    id: 'wall-outlet-ac',
    name: 'Wall Outlet',
    type: 'wall-outlet',
    manufacturer: 'generic',
    price: 0,
    specifications: { power: '230V AC', circuits: '1' }
  },
  {
    id: 'server-1u',
    name: '1U Server',
    type: 'server',
    manufacturer: 'ubiquiti',
    units: 1,
    price: 899,
    specifications: {
      cpu: 'Intel Xeon',
      memory: '16GB',
      storage: '1TB SSD'
    }
  }
];

